module.exports = __webpack_public_path__ + "static/img/video.c74e61ce.png";